<template>
  <li class="video-thumb">
    <button
      type="button"
      class="btn-trigger"
      @click="() => emits('selected', index)"
    >
      <div class="thumb">
        <div class="thumb-img">
          <img :src="thumbnailSrc" alt="" />
        </div>
        <strong class="subject"> {{ props.manual.manualTitleNm }} </strong>
        <div class="thumb-over">
          <i class="c-icon icon-play"></i>
          <span class="sr-only">재생</span>
        </div>
      </div>
    </button>
  </li>
</template>
<script setup>
import { onMounted, defineProps, ref, defineEmits } from "vue";
import noImage from "@/assets/images/common/img_no_product.svg";
import axios from "axios";
import axiosJsonp from "axios-jsonp";

const emits = defineEmits(["selected"]);

const props = defineProps({
  manual: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
});

const thumbnailSrc = ref(noImage);

onMounted(() => {
  setThumbnailSrc();
});

const setThumbnailSrc = async () => {
  const regx = /vimeo\.com\/(\d+)/;

  try {
    const match = props.manual.videoUrl.match(regx);
    const videoId = match[1];

    const response = await axios.get(
      `http://vimeo.com/api/v2/video/${videoId}.json`,
      { adapter: axiosJsonp }
    );

    thumbnailSrc.value = response.data[0].thumbnail_large;
  } catch (error) {
    console.error("Failed to get thumbnail", error);
  }
};
</script>
<style scoped></style>
